import React, { useEffect, useState } from "react";
import { useSearchParams, useParams } from "react-router-dom";
import QrInfo from "../components/QrInfo";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";

const QrDetailsPage = () => {
  //for url like "/v?uid=cdd229d6881b9c3a917d8cced904187d" use below code
  //const [searchParams] = useSearchParams();
  //const key = searchParams.get("uid");
  //for url like "/cdd229d6881b9c3a917d8cced904187d" use below code
  const { key } = useParams();
  const [qrData, setQrData] = useState(null);
  const [isCompleted, setIsCompleted] = useState(false);
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState(""); // New state for OTP
  const [showModal, setShowModal] = useState(false);
  const [showOtpModal, setShowOtpModal] = useState(false); // Modal for OTP input
  const [showCashback, setShowCashback] = useState(false);
  const [showRedeem, setShowRedeem] = useState(false);
  const [cashbackClaimed, setCashbackClaimed] = useState(false);
  const [redeemClaimed, setRedeemClaimed] = useState(false);
  const [schemeId, setSchemeId] = useState(null);
  const [schemeValid, setSchemeValid] = useState(true);
  const [schemeStatusMessage, setSchemeStatusMessage] = useState(null);
  const [showThankYou, setShowThankYou] = useState(false);
  const [isLoading, setIsLoading] = useState(true); // New loading state
  const [errorMessage, setErrorMessage] = useState(null); // New state for error message
  const [name, setName] = useState(""); // Add name field
  const [retailerName, setRetailerName] = useState(""); // Add retailer name field
  const [submitLoading, setSubmitLoading] = useState(false);
  const [otpSubmitLoading, setOtpSubmitLoading] = useState(false);

  // Function to show fake product alert
  const showFakeProductAlert = () => {
    alert("Fake product detected. Please verify the QR code.");
  };

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const fetchCashbackAmount = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/qr/${key}/cashback`);
      const {
        cashback_amount: cashbackAmount,
        cashback_claimed: cashbackClaimed,
        redeem_claimed: redeemClaimed,
        scheme_id: schemeId,
        scheme_valid: schemeValid,
        scheme_status_message: schemeStatusMessage,
      } = response.data;

      setCashbackClaimed(cashbackClaimed);
      setRedeemClaimed(redeemClaimed);
      setSchemeId(schemeId);
      setSchemeValid(schemeValid !== undefined ? schemeValid : true);
      setSchemeStatusMessage(schemeStatusMessage || null);

      // Check if scheme exists but is invalid or has status message
      const schemeInvalidOrHasMessage = schemeId && schemeId !== "null" && (!schemeValid || schemeStatusMessage);

      // Only show scheme modal if scheme exists, not redeemed, valid, and no status message
      if (schemeId && schemeId !== "null" && !redeemClaimed && schemeValid && !schemeStatusMessage) {
        setShowModal(true); // ask for mobile
        setShowRedeem(true); // show scheme div after redeem flow
        setShowCashback(false);
      } else if (cashbackAmount > 0 && !cashbackClaimed) {
        setShowModal(true); // ask for mobile for cashback
        setShowCashback(true);
        setShowRedeem(false);
      } else {
        // No scheme/cashback, or scheme invalid, just show product info
        setShowRedeem(schemeInvalidOrHasMessage); // Show scheme div if invalid/has message
        setShowCashback(false);
        requestLocationUpdated();
      }
      setErrorMessage(null);
    } catch (error) {
      // Only set error message for actual errors
      if (error.response && error.response.status !== 200) {
        setErrorMessage("No Product Data found");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const fetchQrData = async (lat, lon, mobile = null, otp = null) => {
    setIsLoading(true); // Set loading to true before fetching data
    const body = { latitude: lat, longitude: lon };
    if (mobile) body.mobile = mobile;
    if (otp) body.otp = otp;
    if (name) body.name = name; // Add name field
    if (retailerName) body.retailer_name = retailerName; // Add retailer name field

    try {
      const response = await axios.post(`${API_BASE_URL}/qr/${key}`, body);
      const data = response.data;

      // Update product file URLs (added lines)
      // if (data.product) {
      //   const baseUrl = `${API_BASE_URL}/`; // Replace with your actual base URL
      //   data.product.video_file = data.product.video_file
      //     ? `${baseUrl}${data.product.video_file}`
      //     : null; // Add video file URL
      //   data.product.image_file = data.product.image_file
      //     ? `${baseUrl}${data.product.image_file}`
      //     : null; // Add image file URL
      //   data.product.pdf_file = data.product.pdf_file
      //     ? `${baseUrl}${data.product.pdf_file}`
      //     : null; // Add PDF file URL
      // }

      setQrData(data); // Updated QR data with file URLs
      console.log("Product Id:", data.product); // Log the fetched QR data
      setIsCompleted(true);
    } catch (error) {
      setErrorMessage("No Product Data found.");
    } finally {
      setIsLoading(false); // Set loading to false after fetching data
    }
  };

  const requestLocationUpdated = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          if (mobile) {
            fetchQrData(
              position.coords.latitude,
              position.coords.longitude,
              mobile,
              otp
            );
            setShowRedeem(true);
            setShowCashback(true);
          } else {
            fetchQrData(position.coords.latitude, position.coords.longitude);
            setShowRedeem(false);
            setShowCashback(false);
          }
          setShowModal(false);
          setShowOtpModal(false);
        },
        (error) => {
          console.error("Error getting location:", error);
          fetchLocationFromIPUpdated();
        },
        { enableHighAccuracy: true, timeout: 5000, maximumAge: 0 }
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
      fetchLocationFromIPUpdated();
    }
  };

  const fetchLocationFromIPUpdated = () => {
    axios
      .get("https://api.ipify.org?format=json")
      .then((ipResponse) => {
        const ipAddress = ipResponse.data.ip;
        return axios.get(
          `https://api.ipgeolocation.io/ipgeo?apiKey=c3448732606b441d9fda734931ee304e&ip=${ipAddress}`
        );
      })
      .then((locationResponse) => {
        const { latitude, longitude } = locationResponse.data;
        if (mobile) {
          fetchQrData(latitude, longitude, mobile, otp);
          setShowRedeem(true);
          setShowCashback(true);
        } else {
          fetchQrData(latitude, longitude);
          //setShowRedeem(false);
          //setShowCashback(false);
        }
        setShowModal(false);
        setShowOtpModal(false);
      })
      .catch((err) => {
        console.error("Error fetching location from IP:", err);
        setErrorMessage("No Product Data found..");
        fetchQrData(null, null);
      });
  };

  const handleMobileSubmit = async () => {
    if (mobile.trim() && mobile.length === 10 && !submitLoading) {
      setSubmitLoading(true);
      try {
        await axios.post(`${API_BASE_URL}/send-otp-customer`, {
          mobile,
        });
        setShowModal(false);
        setShowOtpModal(true);
      } catch (error) {
        setErrorMessage("No Product Data found....");
        console.error("Error sending OTP:", error);
      } finally {
        setSubmitLoading(false);
      }
    }
  };

  const handleOtpChange = (index, value) => {
    const newOtp = otp.split("");
    newOtp[index] = value;
    setOtp(newOtp.join(""));

    // Move focus to the next input if available
    if (value && index < 3) {
      document.getElementById(`otp-input-${index + 1}`).focus();
    }
  };

  const handleOtpSubmit = async () => {
    if (otp.trim().length === 4 && !otpSubmitLoading) {
      setOtpSubmitLoading(true);
      try {
        await requestLocationUpdated();
      } finally {
        setOtpSubmitLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchCashbackAmount();
  }, [key]);

  useEffect(() => {
    if (showThankYou) {
      setTimeout(() => setShowThankYou(false), 3000);
    }
  }, [showThankYou]);

  return (
    <div>
      {/* Display Circular Progress only when loading and no modals are active */}
      {isLoading && !showModal && !showOtpModal && (
        <div className="flex flex-col justify-center items-center min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
          <div className="mb-4 animate-bounce">
            <span className="text-6xl">⏳</span>
          </div>
          <CircularProgress />
          <p className="mt-4 text-xl font-semibold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">Loading...</p>
        </div>
      )}

      {/* Error Message */}
      {errorMessage && (
        <div className="text-center mt-6 mx-4">
          <div className="inline-block bg-gradient-to-r from-red-50 to-pink-50 border-2 border-red-300 rounded-2xl p-6 shadow-xl">
            <div className="mb-2">
              <span className="text-4xl">⚠️</span>
            </div>
            <p className="text-xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-red-600 to-pink-600">{errorMessage}</p>
          </div>
        </div>
      )}

      {/* Modal for mobile number input */}
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50 backdrop-blur-sm px-4">
          <div className="bg-gradient-to-br from-white to-blue-50 p-8 rounded-3xl max-w-md w-full text-center shadow-2xl border-4 border-blue-200 relative overflow-hidden">
            {/* Decorative elements */}
            <div className="absolute top-3 right-3 animate-bounce">
              <span className="text-3xl">📱</span>
            </div>
            <div className="absolute bottom-3 left-3 animate-pulse">
              <span className="text-3xl">✨</span>
            </div>
            
            {/* Main icon */}
            <div className="mb-4 animate-bounce">
              <span className="text-6xl">🎁</span>
            </div>
            
            <h3 className="mb-6 text-2xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">
              Enter Details to Redeem
            </h3>
            
            <div className="space-y-3">
              <div className="relative">
                <span className="absolute left-4 top-3 text-xl">📞</span>
                <input
                  type="tel"
                  pattern="[0-9]*"
                  value={mobile}
                  maxLength="10"
                  onChange={(e) => setMobile(e.target.value.replace(/\D/g, ""))}
                  placeholder="Mobile Number"
                  className="border-2 border-blue-300 px-12 py-3 rounded-xl w-full text-center text-lg font-semibold focus:outline-none focus:ring-4 focus:ring-blue-200 focus:border-blue-500 transition-all shadow-md"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") handleMobileSubmit();
                  }}
                  disabled={submitLoading}
                />
              </div>
              
              <div className="relative">
                <span className="absolute left-4 top-3 text-xl">👤</span>
                <input
                  type="text"
                  value={name}
                  maxLength="50"
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Your Name (optional)"
                  className="border-2 border-blue-300 px-12 py-3 rounded-xl w-full text-center text-lg focus:outline-none focus:ring-4 focus:ring-blue-200 focus:border-blue-500 transition-all shadow-md"
                  disabled={submitLoading}
                />
              </div>
              
              <div className="relative">
                <span className="absolute left-4 top-3 text-xl">🏪</span>
                <input
                  type="text"
                  value={retailerName}
                  maxLength="50"
                  onChange={(e) => setRetailerName(e.target.value)}
                  placeholder="Retailer Name (optional)"
                  className="border-2 border-blue-300 px-12 py-3 rounded-xl w-full text-center text-lg focus:outline-none focus:ring-4 focus:ring-blue-200 focus:border-blue-500 transition-all shadow-md"
                  disabled={submitLoading}
                />
              </div>
            </div>
            
            <div className="flex justify-center mt-6">
              <button
                onClick={handleMobileSubmit}
                className={`bg-gradient-to-r from-blue-500 to-indigo-600 text-white px-10 py-4 rounded-full text-xl font-bold shadow-xl transform transition-all duration-200 ${
                  submitLoading ? "opacity-50 cursor-not-allowed" : "hover:scale-105 hover:shadow-2xl hover:from-blue-600 hover:to-indigo-700"
                }`}
                disabled={submitLoading}
              >
                {submitLoading ? "⏳ Submitting..." : "🚀 Submit"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal for OTP input */}
      {showOtpModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50 backdrop-blur-sm px-4">
          <div className="bg-gradient-to-br from-white to-green-50 p-8 rounded-3xl max-w-md w-full text-center shadow-2xl border-4 border-green-200 relative overflow-hidden">
            {/* Decorative elements */}
            <div className="absolute top-3 left-3 animate-spin" style={{ animationDuration: '3s' }}>
              <span className="text-3xl">🔐</span>
            </div>
            <div className="absolute top-3 right-3 animate-pulse">
              <span className="text-3xl">✅</span>
            </div>
            <div className="absolute bottom-3 left-1/2 transform -translate-x-1/2 animate-bounce">
              <span className="text-2xl">⬇️</span>
            </div>
            
            {/* Main icon */}
            <div className="mb-4 animate-bounce">
              <span className="text-6xl">📨</span>
            </div>
            
            <h3 className="mb-3 text-2xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-green-600 to-emerald-600">
              Enter OTP
            </h3>
            <p className="text-sm text-gray-600 mb-6 bg-white rounded-lg p-2 shadow-sm">We've sent a code to your mobile number</p>
            
            <div className="flex justify-center gap-3 mb-6">
              {Array.from({ length: 4 }).map((_, index) => (
                <input
                  key={index}
                  id={`otp-input-${index}`}
                  type="tel"
                  pattern="[0-9]*"
                  maxLength="1"
                  value={otp[index] || ""}
                  onChange={(e) =>
                    handleOtpChange(index, e.target.value.replace(/\D/g, ""))
                  }
                  onKeyDown={(e) => {
                    if (e.key === "Enter") handleOtpSubmit();
                  }}
                  className="border-3 border-green-400 px-4 py-4 rounded-2xl text-center w-16 h-16 text-2xl font-bold focus:outline-none focus:ring-4 focus:ring-green-300 focus:border-green-600 transition-all shadow-lg bg-white"
                  disabled={otpSubmitLoading}
                />
              ))}
            </div>
            
            <button
              onClick={handleOtpSubmit}
              className={`bg-gradient-to-r from-green-500 to-emerald-600 text-white px-10 py-4 rounded-full text-xl font-bold shadow-xl transform transition-all duration-200 ${
                otpSubmitLoading ? "opacity-50 cursor-not-allowed" : "hover:scale-105 hover:shadow-2xl hover:from-green-600 hover:to-emerald-700"
              }`}
              disabled={otpSubmitLoading}
            >
              {otpSubmitLoading ? "⏳ Verifying..." : "✨ Verify OTP"}
            </button>
          </div>
        </div>
      )}

      {/* Display QR Information */}
      {!isLoading && qrData && (
        <QrInfo
          qrData={qrData}
          showCashback={showCashback}
          showRedeem={showRedeem}
          redeemClaimed={redeemClaimed}
          cashbackClaimed={cashbackClaimed}
          mobile={mobile}
          schemeStatusMessage={schemeStatusMessage}
        />
      )}
    </div>
  );
};

export default QrDetailsPage;
